import { useLanguage } from '../contexts/LanguageContext';
import { Quote } from 'lucide-react';

const EMNA_PHOTO = 'https://customer-assets.emergentagent.com/job_cf89158a-bcc4-4183-9507-642ba4ecfd15/artifacts/70zq6ns0_Emna%20Sayed.jpg';

export const ContactPersonSection = () => {
  const { t, isRTL } = useLanguage();

  return (
    <section className="py-12 sm:py-16 md:py-32 bg-slate-50" data-testid="contact-person-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-primary">
            {t('contactPerson.title')}
          </h2>
        </div>

        <div className={`grid md:grid-cols-2 gap-8 md:gap-12 items-center ${isRTL ? 'md:flex-row-reverse' : ''}`}>
          {/* Image */}
          <div className={`relative ${isRTL ? 'md:order-2' : ''}`}>
            <div className="relative max-w-sm sm:max-w-md mx-auto">
              <div className="absolute inset-0 bg-brand/20 rounded-2xl transform rotate-3" />
              <img
                src={EMNA_PHOTO}
                alt={t('contactPerson.name')}
                className="relative rounded-2xl shadow-xl w-full h-auto object-cover aspect-[3/4]"
                data-testid="contact-person-image"
              />
            </div>
          </div>

          {/* Content */}
          <div className={`space-y-4 sm:space-y-6 ${isRTL ? 'md:order-1 text-right' : ''}`}>
            <Quote className="w-10 h-10 sm:w-12 sm:h-12 text-brand/30" />
            <div>
              <h3 className="text-2xl sm:text-3xl font-bold text-primary mb-2" data-testid="contact-person-name">
                {t('contactPerson.name')}
              </h3>
              <p className="text-brand font-medium text-base sm:text-lg" data-testid="contact-person-position">
                {t('contactPerson.position')}
              </p>
            </div>
            <p className="text-base sm:text-lg text-slate-600 leading-relaxed" data-testid="contact-person-description">
              {t('contactPerson.description')}
            </p>
            <div className="pt-2 sm:pt-4">
              <a
                href="#contact"
                className="inline-flex items-center gap-2 text-brand font-semibold hover:underline text-sm sm:text-base"
              >
                {t('hero.secondaryBtn')}
                <span className={isRTL ? 'rotate-180' : ''}>→</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
